const DEVELOPMENT_CONFIG = {
 
    base_url: process.env.REACT_APP_API_SERVER ? process.env.REACT_APP_API_SERVER : 'https://admin-api.dev.notenetic.com/api',    //base_url: 'https://localhost:32770/api',
    statusCode: 200,
    unAuthorized: 401,
    serverError: 501,
    TOKEN: 'token',
    OTP_TOKEN: 'otpToken',
    REFRESH_TOKEN: 'refeshtoken',
    LOGIN_TIME: 'loginTime',
    TOKEN_EXPIRETIME: 'accessTokenExpireTime',
    REFRESHTOKEN_EXPIRETIME: 'refeshTokenExpireTime',
    LAST_URL: 'lasturl',
    Document_Template_S3_Url: 'https://y1n0ha0yf5.execute-api.us-east-1.amazonaws.com/api/convert',
 
 
}
export default (process.env.NODE_ENV === 'development' ? DEVELOPMENT_CONFIG : DEVELOPMENT_CONFIG);



